<div class="page-title-area reseller-hosting-title">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Directorio de Servicios</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Servicios</li>
                        <li>Directorio de Servicios</li>
                    </ul>
                </div>
            </div>

            <div class="special-intro-offer-wrap">
                <div style="background-color: unset !important;" class="search-domain-area-four">
                    <div class="container">
                        <div class="align-items-center">

                            <div class="col-lg-12 col-md-12">
                                <div class="search-domain">
                                    <form class="domain-wrap">
                                        <input maxlength="50"  [(ngModel)]="search"  type="text" class="input-domain"placeholder="Palabras clave o nombres de los servicios que busca." name="Domain">
                                        <button class="default-btn"(click)="searchServices()">Buscar</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="results.length > 0">

                <div class="row">
                    <a style="color: #FFFFFF;"><strong>Búsqueda: </strong>"{{this.query}}"</a>
                    <div *ngFor="let item of results" class="col-lg-4 col-sm-6 pointer">
                        <div routerLink="{{item.route}}" class="reseller-item">
                            <i class="{{item.icon}}"></i>
                            <h5 style="color: #FFFFFF;">{{item.name}}</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="results.length === 0">
                <a style="color: #FFFFFF;"><strong>Búsqueda: </strong>"{{this.query}}"</a>
                <div class="col-lg-12 col-sm-12">
                    <div class="reseller-item">
                        <i class="fa-solid fa-triangle-exclamation"></i>
                        <p style="color: #FFFFFF;">No se encontraron resultados.</p>
                    </div>
                </div>
               
              </div>
            </div>
        </div>
    </div>
</div>


<app-contact-form [section]="section" [pt]="pt" [pb]="pb" [title]="title"></app-contact-form>